const chartwellFunctions = (function($) {
    const init = function () {
        alertContainer();
        navigationAccessible();
        owlCase();
        owlExpert();
        searchForm();
        teamFilter();
        iframeWrap();
    },
    alertContainer = function(){
        $('.close-alert').on('click', function(){
            $('#alert-container').slideToggle();
        })
    },
    iframeWrap = function(){
        $('.site-main iframe').wrap('<div class="video-responsive"></div>');
    },
    navigationAccessible = function(){
        $('.mega-sub > a').on('click', function(e){
            e.preventDefault();
            if($(this).parent().hasClass('active')){
                $(this).parent().removeClass('active');
            } else {
                $('.mega-sub').removeClass('active');
                 $(this).parent().addClass('active');
            }
           
        })
    }, 
    owlCase = function(){
        $('.owl-case-study').owlCarousel({
            items: 1,
            nav: true,
            dots: false,
            navText:['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'], 
        });
    },
    owlExpert = function(){
        $('.owl-expert').owlCarousel({
            items: 1,
            nav: true,
            dots: false,
            navText:['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'], 
        });
    },
    searchForm = function () {
        $sbtn = $('.super-header .search-form');
        $sdd = $('.search-dd');
        
        $sbtn.click(function (event) {
            $('.search-dd').slideToggle();
          //$(this).closest('.site-header').next().toggleClass('active');
          //$(this).closest('.site-header').next().focus();
          //event.stopPropagation();
        });
  
        $(document).on('click', function (e) {
          if ($(e.target).closest($sdd).length === 0) {
            $($sdd).removeClass('active');
          }
        });
  
  
    }, 
    teamFilter = function () {
        $('.cat-list_item').on('click', function() {
            $('.cat-list_item').removeClass('active');
            $(this).addClass('active');
            console.log($(this).data('slug'));
            $.ajax({
              type: 'POST',
              url: '/wp-admin/admin-ajax.php',
              dataType: 'html',
              data: {
                action: 'filter_members',
                category: $(this).data('slug'),
              },
              success: function(res) {
                $('.team-section .team-single').hide();
                //$('.team-section').hide();
                $('.team-section').html(res);
                //$('.team-section').fadeIn('slow');
                $('.team-section .team-single').addClass('ajax-content-animate');
              }
            })
          });
    }
    
    return {
        init: init
    };


})(jQuery );

jQuery(document).ready(chartwellFunctions.init);